// extracted by mini-css-extract-plugin
export var clauseRow = "_cr-6";
export var emptyState = "_cr-d";
export var filterContent = "_cr-a";
export var filterGroup = "_cr-1";
export var filterGroupContainer = "_cr-0";
export var nestedGroup = "_cr-2";
export var nestedGroupContent = "_cr-b";
export var nestedGroupDepth1 = "_cr-3";
export var nestedGroupDepth2 = "_cr-4";
export var nestedGroupDepth3 = "_cr-5";
export var nestedGroupEmpty = "_cr-c";
export var operatorAnd = "_cr-8";
export var operatorOr = "_cr-9";
export var operatorToggle = "_cr-7";
export var removeGroupButton = "_cr-e";